import React, { Component } from 'react';
import {API} from 'aws-amplify';
import './hsiTableRow.css';
import tickIcon from '../../../../universal/images/tickIcon.svg';
import crossIcon from '../../../../universal/images/crossIcon.svg';

class HsiTableRow extends Component {

  state = {
    expanded: false,
    ConfirmHybris: undefined
  };

  componentDidMount() {

  };

  render() {

    const tcIcon = tick => {
      if (tick) return <img src={tickIcon} alt={'Tick Icon'} height={20} width={20}/>;
      else return <img src={crossIcon} alt={'Cross Icon'} height={20} width={20}/>;
    };

    const {domain} = this.props;

    return (
      <React.Fragment>
        <tr className={`${this.state.ConfirmHybris || domain.ConfirmHybris}Row`} onClick={this.handleExpand}>
          <td>{domain.GlobalRank}</td>
          <td>{domain.Domain}</td>
          <td>{domain.HybrisScore}</td>
          <td>{this.state.ConfirmHybris || domain.ConfirmHybris}</td>
          <td>{domain['sp-acc'] ? 'True' : 'False'} {tcIcon(domain['sp-acc'])}</td>
          <td>{domain['sp-mediassysmaster'] ? 'True' : 'False'} {tcIcon(domain['sp-mediassysmaster'])}</td>
          <td>{domain['sp-acc.config'] ? 'True' : 'False'} {tcIcon(domain['sp-acc.config'])}</td>
          <td>{domain['sp-uidesktoptheme'] ? 'True' : 'False'} {tcIcon(domain['sp-uidesktoptheme'])}</td>
          <td>{domain['sp-yCmsComponent'] ? 'True' : 'False'} {tcIcon(domain['sp-yCmsComponent'])}</td>
          <td>{domain['sp-mobiletheme'] ? 'True' : 'False'} {tcIcon(domain['sp-mobiletheme'])}</td>
          <td>{domain['sp-yCmsContentSlot'] ? 'True' : 'False'} {tcIcon(domain['sp-yCmsContentSlot'])}</td>
          <td>{domain['sp-responsivetheme'] ? 'True' : 'False'} {tcIcon(domain['sp-responsivetheme'])}</td>
          <td>{domain['sp-commonjs'] ? 'True' : 'False'} {tcIcon(domain['sp-commonjs'])}</td>
          <td>{domain['sp-desktoptheme'] ? 'True' : 'False'} {tcIcon(domain['sp-desktoptheme'])}</td>
          <td>{domain['sp-hybris'] ? 'True' : 'False'} {tcIcon(domain['sp-hybris'])}</td>
          <td>{domain['li-c'] ? 'True' : 'False'} {tcIcon(domain['li-c'])}</td>
          <td>{domain['li-p'] ? 'True' : 'False'} {tcIcon(domain['li-p'])}</td>
          <td>{domain['ur-smartedit']}</td>
          <td>{domain['ur-backoffice']}</td>
          <td>{domain['ur-hmc']}</td>
          <td>{domain['ur-productcockpit']}</td>
          <td>{domain['ur-hac']}</td>
          <td>{domain['ur-cmscockpit']}</td>
        </tr>
        {this.state.expanded &&
          <tr>
            <td colSpan="23">
              <a href={`https://${domain.Domain}`} target="_blank">WEBSITE</a> - <a href={`https://builtwith.com/${domain.Domain}`} target="_blank">BUILTWITH</a>
              <button onClick={() => this.handleConfirmHybris('Hybris')}>CONFIRM HYBRIS</button>
              <button onClick={() => this.handleConfirmHybris('NotHybris')}>DECONFIRM HYBRIS</button>
              <button onClick={() => this.handleConfirmHybris('Unknown')}>UNKNOWN HYBRIS</button>
            </td>
          </tr>
        }
      </React.Fragment>
    );

  };

    handleExpand = () => {
      this.setState({expanded: !this.state.expanded});
    }

    handleConfirmHybris = State => {
      API.get('HSI', '/confirmhybris', {queryStringParameters: {HybrisScore: this.props.domain.HybrisScore, GlobalRank: this.props.domain.GlobalRank, State}})
      .then(res => {
        this.setState({ConfirmHybris: res.Attributes.ConfirmHybris});
      })
      .catch(err => {
        console.log(err);
      });
    }

};

export default HsiTableRow;


// WEBPACK FOOTER //
// ./src/components/content/hybrisSiteIdentifier/hsiMain/hsiTableRow/hsiTableRow.js